import { Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { ChevronLeft, ChevronRight } from "@material-ui/icons";
import settings from "@styles/settings";
import React, { useContext } from "react";
import theme from "../../styles/theme";
import { TextContext } from "@pages/bepaal-statuut";

const radius = "25px";

const useStyles = makeStyles({
  button: {
    margin: "20px",
  },
  backButton: {
    margin: "20px",
    backgroundColor: theme.palette.primary.light,
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
    },
  },
  left: {
    borderRadius: `${radius} 0px 0px ${radius}`,
  },
  right: {
    borderRadius: `0px ${radius} ${radius} 0px`,
  },
  hoverButtonBack: {
    "&:hover": {
      backgroundColor: "#efefef",
    },
  },
});

const NavigationButtons = (props: { onBack: any; onNext: any }) => {
  // const biggerThanSm = useMediaQuery(theme.breakpoints.up("sm"));
  const classes = useStyles();
  const text = useContext(TextContext);

  return (
    <div
      style={{
        // position: "fixed",
        // bottom: "0",
        // left: "0",
        width: "100%",
        height: settings.navigationButtonsBarHeight,
        // marginBottom: 40,
        backgroundColor: "rgb(240, 237, 237,1)",
        display: "flex",
        justifyContent: "space-between",
        // boxShadow: theme.shadows[5],
      }}
    >
      <Button
        color="primary"
        style={{
          minWidth: "130px",
          textAlign: "center",
        }}
        className={classes.backButton}
        onClick={props.onBack}
        variant="contained"
      >
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            paddingRight: "10px",
          }}
        >
          <ChevronLeft htmlColor={"white"} /> {text.general_button_previous}
        </div>
      </Button>
      <Button
        color="secondary"
        variant="contained"
        className={classes.button}
        onClick={props.onNext}
        style={{ minWidth: "130px" }}
      >
        {text.general_button_next} <ChevronRight htmlColor={"white"} />
      </Button>
    </div>
  );
};

export default NavigationButtons;
